import { SPRITE_SIZE, spriteById, spriteRuns } from "@buildlab/shared/sprites";

// Profile icons (decision 84): the 16×16 pixel-art sprites from @buildlab/shared, drawn as crisp SVG
// pixels like Roary (Lion.tsx). Keep `size` a multiple of 16 so every pixel stays square and sharp.

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter((w) => /^\p{L}/u.test(w))
    .map((w) => w[0]!.toUpperCase())
    .slice(0, 2)
    .join("");

/** One sprite. Decorative unless given a label (pass the sprite's name for alt text). */
export function SpriteIcon({ id, size = 32, label, className }: { id: string; size?: number; label?: string; className?: string }) {
  const sprite = spriteById(id);
  if (!sprite) return null;
  return (
    <svg
      className={`sprite${className ? ` ${className}` : ""}`}
      viewBox={`0 0 ${SPRITE_SIZE} ${SPRITE_SIZE}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {spriteRuns(sprite).map((r, i) => (
        <rect key={i} x={r.x} y={r.y} width={r.w} height={1} fill={r.c} />
      ))}
    </svg>
  );
}

/**
 * Someone's avatar: the icon they picked, or their initials in a blue square when they haven't.
 * Decorative (the name is always shown beside it); `size` is the sprite's size in CSS pixels.
 */
export function Avatar({ name, avatar, size = 32, className }: { name: string; avatar?: string | null; size?: number; className?: string }) {
  const sprite = spriteById(avatar);
  return (
    <span className={`avatar${sprite ? " has-sprite" : ""}${className ? ` ${className}` : ""}`} aria-hidden="true" title={sprite?.name}>
      {sprite ? <SpriteIcon id={sprite.id} size={size} /> : initials(name)}
    </span>
  );
}
